import { App } from 'vue'
import { Lazyload, Loading, Cell, CellGroup, Icon, Field, Picker, Popup, Toast, SwipeCell } from 'vant'
import 'vant/lib/index.css'

export default (app: App<Element>) => {
  app.use(Lazyload)
  app.use(Loading)
  app.use(Cell)
  app.use(CellGroup)
  app.use(Icon)
  app.use(Field)
  app.use(Picker)
  app.use(Popup)
  app.use(Toast)
  app.use(SwipeCell)
}
